// TODO: TEMPORARY - the year list is hardcoded to 2023–2030 so that future years
// are selectable. Remove this year filter dropdown (and this helper) once the
// date-range based filter replaces it.
// export const YearSelect = () => {
//     // Generate a static array of years from 2023 to 2030
//     const years = [];
//     for (let year = 2023; year <= 2030; year++) {
//       years.push(year);
//     }

//     // Map the years to the format required by Select options
//     const yearOptions = years.map(year => ({ value: year.toString(), label: year.toString() }));

//     return yearOptions
//   };

export const YearSelect = () => {
  // Get the current year
  const currentYear = new Date().getFullYear();

  // Generate an array of years from 2023 to the current year
  const years = [];
  for (let year = 2023; year <= currentYear; year++) {
    years.push(year);
  }

  // Map the years to the format required by Select options
  const yearOptions = years.map(year => ({ value: year.toString(), label: year.toString() }));

  return yearOptions
};

export const capitalizeFirst = (str) => {
  if (!str) return "";

  return str.toString()
    .split(" ")
    .map(word => {
      // Check if the word is all uppercase (acronym)
      if (word === word.toUpperCase() && word !== word.toLowerCase()) {
        return word; // Keep it as is
      }
      // Otherwise, capitalize first letter
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
};

// A LeaveApplication's `leave` field stores "optional_leave" (the raw slug the
// apply flow hardcodes) for leaves applied via the optional-holiday picker - this
// maps it to the same "Optional Holiday" label used everywhere else, so leave
// lists don't show the raw slug. Every other leave type's `leave` value is
// already the real display name, so this is a no-op for them.
export const formatLeaveName = (str) => {
  if (String(str || "").trim().toLowerCase() === "optional_leave") return "Optional Holiday";

  return capitalizeFirst(str);
};